

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const MANAGEMENTREGISTERFORCUSTOMER= createAsyncThunk(
  "managementRegisterForCustomer/managementRegisterForCustomer",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const managementRegisterForCustomerSlice = createSlice({
  name: "managementRegisterForCustomerSlice",
  initialState: {
    managementRegisterForCustomer: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfmanagementRegisterForCustomer: (state) => {
        state.managementRegisterForCustomer.loading = false
        state.managementRegisterForCustomer.error = false
        state.managementRegisterForCustomer.data = []
        state.managementRegisterForCustomer.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(MANAGEMENTREGISTERFORCUSTOMER.fulfilled, (state, action) => {
      state.managementRegisterForCustomer = {
        ...state.managementRegisterForCustomer,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(MANAGEMENTREGISTERFORCUSTOMER.pending, (state, action) => {
      state.managementRegisterForCustomer = {
        ...state.managementRegisterForCustomer,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(MANAGEMENTREGISTERFORCUSTOMER.rejected, (state, action) => {
      state.managementRegisterForCustomer = {
        ...state.managementRegisterForCustomer,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const managementRegisterForCustomerAction = {
    MANAGEMENTREGISTERFORCUSTOMER,
};

export { managementRegisterForCustomerAction };
export default managementRegisterForCustomerSlice.reducer;
export const {setInitialStateOfmanagementRegisterForCustomer} = managementRegisterForCustomerSlice.actions
